<svg-icon key="general:x-close"></svg-icon>
